import Vue from "vue";
import Router from "vue-router";
import Index from "@/pages/home/index";
import Login from "@/pages/user/login";
import LoginInit from "@/pages/user/LoginInit";
import Forget from "@/pages/user/forget";
import CategoryHome from "@/pages/category/index";
import ProductsList from "@/pages/products/list";
import ProductsDetail from "@/pages/products/detail";
import ShoppingCart from "@/pages/shopping-cart/index";
import CheckOrder from "@/pages/order/check-order";
import SubmitOrder from "@/pages/order/submit-order";
import UserCenter from "@/pages/user/user-center";
import ChangePassword from "@/pages/user/change-password";
import OrderList from "@/pages/user/order-list";
import OrderDetail from "@/pages/user/order-detail";
import UserAddress from "@/pages/user/user-address";
import RefundList from "@/pages/user/refund-list";
import RefundDetail from "@/pages/user/refund-detail";
import RefundSubmit from "@/pages/user/refund-submit";
import Recharge from "@/pages/user/recharge";
import Introduce from "@/pages/introduce/index";
import Business from "@/pages/introduce/business";
import Agreement from "@/pages/introduce/agreement";
// 趣运动
import QYDHome from "@/pages/category/qyd-home";
import QYDDetail from "@/pages/products/qyd-detail";
import QYDCheckOrder from "@/pages/order/qyd-check-order";
import QYDSubmitOrder from "@/pages/order/qyd-submit-order";
import QYDOrderList from "@/pages/user/qyd-order-list";
import QYDOrderDetail from "@/pages/user/qyd-order-detail";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "index",
      component: Index
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/login/init-storage/:params",
      name: "login-init",
      component: LoginInit
    },
    {
      path: "/forget",
      name: "forget",
      component: Forget
    },
    {
      path: "/categoryHome",
      name: "category-home",
      component: CategoryHome
    },
    {
      path: "/productList",
      name: "products-list",
      component: ProductsList
    },
    {
      path: "/productDetail",
      name: "product-detail",
      component: ProductsDetail
    },
    {
      path: "/shoppingCart",
      name: "shopping-cart",
      component: ShoppingCart
    },
    {
      path: "/checkOrder",
      name: "check-order",
      component: CheckOrder
    },
    {
      path: "/submitOrder/:order_id",
      name: "submit-order",
      component: SubmitOrder
    },
    {
      path: "/userCenter",
      name: "user-center",
      component: UserCenter
    },
    {
      path: "/userCenter-H",
      name: "user-center-history",
      component: OrderList
    },
    {
      path: "/changePassword",
      name: "change-password",
      component: ChangePassword
    },
    {
      path: "/orderList",
      name: "order-list",
      component: OrderList
    },
    {
      path: "/evaluate",
      name: "evaluate",
      component: () => import("../pages/user/evaluate.vue")
    },
    {
      path: "/OrderDetail/:order_id",
      name: "order-detail",
      component: OrderDetail
    },
    {
      path: "/userAddress",
      name: "user-address",
      component: UserAddress
    },
    {
      path: "/coupon",
      name: "coupon-list",
      component: () => import("@/pages/user/coupon.vue")
    },
    {
      path: "/refundList",
      name: "refund-list",
      component: RefundList
    },
    {
      path: "/refundDetail/:workorder_id",
      name: "refund-detail",
      component: RefundDetail
    },
    {
      path: "/refundSubmit/:product_id",
      name: "refund-submit",
      component: RefundSubmit
    },
    {
      path: "/recharge",
      name: "recharge",
      component: Recharge
    },
    {
      path: "/introduce",
      name: "introduce",
      component: Introduce
    },
    {
      path: "/agreement",
      name: "agreement",
      component: Agreement
    },
    {
      path: "/business",
      name: "business",
      component: Business
    },
    {
      path: "/quyundong/home",
      name: "qyd-home",
      component: QYDHome
    },
    {
      path: "/quyundong/detail",
      name: "qyd-detail",
      component: QYDDetail
    },
    {
      path: "/quyundong/checkOrder",
      name: "qyd-check-order",
      component: QYDCheckOrder
    },
    {
      path: "/quyundong/submitOrder/:order_id",
      name: "qyd-submit-order",
      component: QYDSubmitOrder
    },
    {
      path: "/quyundong/orderList",
      name: "quyundong-order-list",
      component: QYDOrderList
    },
    {
      path: "/quyundong/OrderDetail/:order_id",
      name: "qyd-order-detail",
      component: QYDOrderDetail
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js